/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Pressable,
  TouchableOpacity,
  View,
} from 'react-native';
import React, {
  useState,
} from 'react';
import Svg, {
  Polygon,
} from 'react-native-svg';
import Button from '@components/common/Button';
import {
  Portal,
} from 'react-native-paper';
import getStyles from './styles';
import hooks from '@hooks';

const Popover = (props: PopoverProps) => {
  const [_open, setOpen] = useState(!!props.initiallyOpen); // @TODO: need this now that we have coords?
  const [_popoverPosition, setPopoverPosition] = useState({x: 0, y: 0});

  const styles = hooks.useStyles(getStyles, {touchPosn: _popoverPosition});

  return (
    <React.Fragment>
      <TouchableOpacity
        disabled={props.disabled}
        onPressIn={(event) => {
          // @TODO: maybe makes the most sense to save the position of the element rather than the touch itself
          setPopoverPosition({
            x: event.nativeEvent.pageX,
            y: event.nativeEvent.pageY,
          });
          setOpen(true);
        }}
      >
        {props.children}
      </TouchableOpacity>
      <Portal>
        {_open &&
          <React.Fragment>
            <TouchableOpacity
              style={styles.absoluteFill}
              disabled={props.disabled}
              onPress={() => {
                setOpen(false);
              }}
            >{/* @TODO: better function */}
              <Pressable
                style={styles.popoverWrapper}
                onPress={() => {}} // @TODO: to prevent closing
              >
                <React.Fragment>
                  {typeof props.popover === 'function' ? props.popover(setOpen) : props.popover}
                  {!!props.actions &&
                    <View style={styles.actionsWrapper}>
                      {props.actions.map((action) => {
                        return (
                          <Button
                            key={action.text}
                            containerStyle={styles.popoverButton}
                            mode='contained'
                            theme={styles.colors.accent}
                            onPress={() => {
                              action.onPress?.();
                              setOpen(false);
                            }}
                            {...action.otherProps}
                          >
                            {action.text}
                          </Button>
                        );
                      })}
                    </View>
                  }
                </React.Fragment>
              </Pressable>
            </TouchableOpacity>
            <Svg style={styles.arrow}>
              <Polygon
                points='2,10 10,0 18,10'
                fill={styles.colors.primary}
                transform={_popoverPosition.y >= (styles.windowHeight / 2) ? 'rotate(180 10 5)' : undefined}
              />
            </Svg>
          </React.Fragment>
        }
      </Portal>
    </React.Fragment>
  // @TODO: add buttons back
  );
};

class PopoverProps {
  popover: React.ReactNode | ((setOpen: (open: boolean) => void) => React.ReactNode);
  children: React.ReactNode;

  actions?: any[]; // @TODO: of objects of shape {text: string, onPress: func, otherProps: object}
  disabled?: boolean;
  initiallyOpen?: boolean;
};

Popover.displayName = 'Popover';
export default Popover;
